import InitState from './states/InitState'
import LoadingState from "@/states/states/LoadingState";
import IdleState from './states/IdleState'
import FinalState from './states/FinalState'
import PreSpinStartState from './states/PreSpinStartState'
import SpinStartState from './states/SpinStartState'
import GetSpinResponseState from './states/GetSpinResponseState'
import SpinStopState from './states/SpinStopState'
import ShowWinningsState from "./states/ShowWinningsState";
import ShowCycleWinningsState from "./states/ShowCycleWinningsState";

import StartCountingUpWinningsState from "./states/StartCountingUpWinningsState";
import IntroBonusState from "./states/IntroBonusState";
import OutroBonusState from "./states/OutroBonusState";
import BigWinState from "./states/BigWinState";
import StateMachine from "@state/StateMachine"
import Signals from "@/signals/GameSignals"
import BonusState from "@/states/states/BonusState";
import OutroFreespinsState from "@/states/states/OutroFreespinsState";
import BonusWinnigsAddingState from "./states/BonusWinnigsAddingState";
import FreeSpinsIntroState from "@/states/states/FreeSpinsIntroState";
import GetBuyFreespinResponseState from "./states/GetBuyFreespinResponseState";
import FreeSpinsBuyState from "@/states/states/FreeSpinsBuyState";


export default class GameStateMachine extends StateMachine {
  constructor (model, stateEnum) {
    super(model, stateEnum)
  }

  init(gameStatesEnum) {
    super.init(gameStatesEnum)
    this.addState(InitState, this.statesEnum.INIT)
    this.addState(LoadingState, this.statesEnum.LOADING)
    this.addState(IdleState, this.statesEnum.IDLE)
    this.addState(PreSpinStartState, this.statesEnum.PRE_SPIN_START)
    this.addState(SpinStartState, this.statesEnum.SPIN_START)
    this.addState(GetSpinResponseState, this.statesEnum.GET_SPIN_RESPONSE)
    this.addState(GetBuyFreespinResponseState, this.statesEnum.GET_BUY_FREESPIN_RESPONSE)
    this.addState(SpinStopState, this.statesEnum.SPIN_STOP)
    this.addState(FinalState, this.statesEnum.FINAL)
    this.addState(ShowWinningsState, this.statesEnum.SHOW_WINNINGS)
    this.addState(BigWinState, this.statesEnum.SHOW_BIGWIN)
    this.addState(StartCountingUpWinningsState, this.statesEnum.START_COUNTUP_WINNINGS)
    this.addState(ShowCycleWinningsState, this.statesEnum.SHOW_CYCLEWINNINGS)
   // this.addState(IntroBonusState, this.statesEnum.INTRO_BONUS)
    this.addState(BonusState, this.statesEnum.BONUS_GAME)
   // this.addState(OutroBonusState, this.statesEnum.OUTRO_BONUS)
   // this.addState(BonusWinnigsAddingState, this.statesEnum.BONUS_WIN_ADD)
    this.addState(OutroFreespinsState, this.statesEnum.OUTRO_FREESPINS)
    this.addState(FreeSpinsIntroState, this.statesEnum.FREE_SPINS_INTRO)
    this.addState(FreeSpinsBuyState, this.statesEnum.FREE_SPINS_BUY)
  }

  stateChanged(id, model) {
    console.log('GameStateMachine : stateChanged', id)
    super.stateChanged(id, model)
    Signals.stateChanged.dispatch(id, model)
  }
}
